var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilm = function SvgFilm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.417 30A4.583 4.583 0 0 0 10 34.584h20A4.583 4.583 0 0 0 34.583 30V10A4.583 4.583 0 0 0 30 5.417H10A4.583 4.583 0 0 0 5.417 10zm3.11-21.473c.39-.39.92-.61 1.473-.61h2.083v4.166H7.917V10c0-.552.22-1.082.61-1.473m23.556 16.89V21.25h-4.166v4.167zm-4.166 2.5h4.166V30A2.083 2.083 0 0 1 30 32.084h-2.083zm-2.5-6.667H14.583v10.834h10.834zM32.083 10v2.083h-4.166V7.917H30A2.083 2.083 0 0 1 32.083 10m0 8.75v-4.167h-4.166v4.167zM25.417 7.917V18.75H14.583V7.917zM7.917 21.25v4.167h4.166V21.25zm4.166-2.5H7.917v-4.167h4.166zM7.917 30v-2.083h4.166v4.167H10A2.083 2.083 0 0 1 7.917 30",
    clipRule: "evenodd"
  })));
};
export default SvgFilm;